import styled from 'styled-components';

export const Covid19BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  background: #e9f1f6;
  font-size: 16px !important;

  .is-bold {
    font-weight: bold;
  }

  @media (max-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 12px;
    font-size: 13px !important;
  }
`;

export const TextContent = styled.div`
  margin-left: 8px;
`;

export const Link = styled.a`
  display: inline;
  white-space: nowrap;
  color: ${props => props.theme.carvana.blue.primary};

  &:hover {
    color: ${props => props.theme.carvana.blue.hover};
    cursor: pointer;
  }
`;

export const Image = styled.img``;
